import { useCancelRequestHook } from "@op/hooks/useCancelRequest";
import { dealWithMentionsSentimentList, dealWithSentimentSmallChart } from "@op/pages/Overview/KeyMetrics/utils";
import { getOverviewMentionsSentiment } from "@op/services";
import { getMentionsStatsList } from "@op/services/keyMetrics";
import { useEffect, useState } from "react";

/**
 * 获取Mentions & Sentiment 的指标数据
 * @param filter
 * @param formatData
 * @param extraData
 * @returns
 */
export function useKeyMetricsMentionsList({ filter, extraData }: any) {
  const [records, setRecords] = useState<any>({});
  const [error, setError] = useState(false);
  const { loading, wrapperRequest } = useCancelRequestHook();
  function requestChart() {
    if (!filter.edition_unified_id) return;
    setError(false);
    wrapperRequest((cancelFunc) =>
      getMentionsStatsList(filter, cancelFunc)
        .then((data: any) => {
          const formattedData = dealWithMentionsSentimentList(
            data,
            filter,
            extraData,
          );
          setRecords(formattedData);
        })
        .catch(() => {
          setError(true);
        }),
    );
  }

  useEffect(() => {
    if (!filter?.date_type) return;
    requestChart();
  }, [filter]);

  return { data: records, loading, error, refetch: requestChart };
}

export function useKeyMetricsSentimentList({ filter, extraData }: any) {
  const [records, setRecords] = useState<any>({});
  const [error, setError] = useState(false);
  const { loading, wrapperRequest } = useCancelRequestHook();
  function requestChart() {
    if (!filter.edition_unified_id) return;
    setError(false);
    wrapperRequest((cancelFunc) =>
      getOverviewMentionsSentiment(filter, cancelFunc)
        .then((data: any) => {
          const formattedData = dealWithSentimentSmallChart(
            data,
            filter,
            extraData,
          );
          setRecords(formattedData);
        })
        .catch(() => {
          setError(true);
        }),
    );
  }

  useEffect(() => {
    if (!filter?.date_type) return;
    requestChart();
  }, [filter]);

  return { data: records, loading, error, refetch: requestChart };
}